/**
 * The screens anyone may open, with nobody logged in. Read by every route middleware, so a public
 * screen is never sent to Log In or asked for a warehouse.
 *
 * `/gun-setup` is here because a gun that does not scan cannot scan a badge card to log in
 * (Mark, 2026-10-15): it is reached from the Log In screen.
 */
export const PUBLIC_PATHS: ReadonlySet<string> = new Set([
  '/login',
  '/gun-setup',
  '/forgot-password',
  '/reset-password',
  '/accept-invite',
  '/not-authorized',
])

export function isPublicPath(path: string): boolean {
  return PUBLIC_PATHS.has(path)
}
